import { Appeals } from "~/entity/Appeals/api/service";
import { TAppealFilter } from "~/entity/Appeals/model/schema";
import { TFilterDealerGroup } from "~/shared/model/types";

export const useAppeals = () => {
  const queryKeys = {
    allWOFilter: [Appeals._routes.appeals],
    all: (filter: TAppealFilter) => [Appeals._routes.appeals, filter],
    byId: (id: string | number) => [Appeals._routes.appeals, id],
    appealContacts: (filter: TFilterDealerGroup) => [
      Appeals._routes.appealContacts,
      filter,
    ],
  };

  // GET
  const getAppeal = Appeals.GET.appealsList;
  const getAppealById = Appeals.GET.byId;
  const getAppealContacts = Appeals.GET.appealContacts;
  const getAppealPeriod = Appeals.GET.appealPeriods;
  const getAppealReport = Appeals.GET.report;

  // PUT
  const setAppeal = Appeals.PUT.set;
  const setAppealPeriod = Appeals.PUT.setAppealPeriods;
  const setAppealDecision = Appeals.PUT.appealDecision;

  // POST
  const sentAppeal = Appeals.POST.sent;
  const needInfoAppeal = Appeals.POST.needInfo;
  const reviewAppeal = Appeals.POST.review;
  const closeAppeal = Appeals.POST.close;
  const addFile = Appeals.POST.addFile;

  // DELETE
  const deleteFile = Appeals.DELETE.deleteFile;

  return {
    queryKeys,

    // GET
    getAppeal,
    getAppealById,
    getAppealContacts,
    getAppealPeriod,
    getAppealReport,

    // PUT
    setAppeal,
    setAppealPeriod,
    setAppealDecision,

    // POST
    sentAppeal,
    needInfoAppeal,
    reviewAppeal,
    closeAppeal,
    addFile,

    // DELETE
    deleteFile,
  };
};
